export enum InvoicingStrategyType {
  CreationDate = "CreationDate",
  ExecutionDate = "ExecutionDate"
}
